<template>
  <div>
    <el-container>
      <el-header height="48px" style="line-height: 48px;">
        <el-row>
          <el-col :span="12">
            <span>
              <span>包件编码：</span>
              <span>{{formData.packCode}}</span>
            </span>
            &nbsp;
            &nbsp;
            <span>
              <span>包件名称：</span>
              <span>{{formData.packName}}</span>
            </span>
          </el-col>
          <el-col :span="12">
            <el-tabs v-model="activeName">
              <el-tab-pane label="缺货包件在制/寄存分布" name="jcfb" :disabled="true"></el-tab-pane>
              <el-tab-pane label="采购部回复" name="cgbReply" :disabled="true"></el-tab-pane>
              <el-tab-pane label="计划部回复" name="jhbReply"></el-tab-pane>
            </el-tabs>
          </el-col>
        </el-row>
      </el-header>
      <el-main>
        <component :is="curComponent" :data="formData"></component>
      </el-main>
    </el-container>
  </div>
</template>

<script>
import jhbReply from './child/jhbReply/jhbReply'
export default {
  components: { jhbReply },
  props: ['data'],
  data() {
    return {
      activeName: 'jhbReply'
    }
  },
  computed: {
    formData() {
      return this.data
    },
    curComponent() {
      return this.activeName
    }
  }
}
</script>

<style lang="stylus" scoped>

</style>